import { MGPOptional } from '@everyboard/lib';
import { Coord } from '../../../jscaip/Coord';
import { GobanUtils } from '../../../jscaip/GobanUtils';
import { PlayerNumberMap } from '../../../jscaip/PlayerMap';
import { AbstractGoRules } from '../AbstractGoRules';
import { OrthogonalGoGroupDataFactory } from '../GoGroupDataFactory';
import { GoPhase } from '../GoPhase';
import { GoPiece } from '../GoPiece';
import { GoState } from '../GoState';
export class AbstractRectangularGoRules extends AbstractGoRules {
    getZoom(config) {
        return config.zoom;
    }
    getInitialState(config) {
        const board = GoState.getStartingBoard(config.width, config.height);
        let turn = 0;
        const left = GobanUtils.getHorizontalLeft(config.width);
        const right = GobanUtils.getHorizontalRight(config.width);
        const up = GobanUtils.getVerticalUp(config.height);
        const down = GobanUtils.getVerticalDown(config.height);
        const horizontalCenter = GobanUtils.getHorizontalCenter(config.width);
        const verticalCenter = GobanUtils.getVerticalCenter(config.height);
        const orderedHandicaps = [
            new Coord(left, up),
            new Coord(right, down),
            new Coord(right, up),
            new Coord(left, down),
            new Coord(horizontalCenter, verticalCenter),
            new Coord(horizontalCenter, up),
            new Coord(horizontalCenter, down),
            new Coord(left, verticalCenter),
            new Coord(right, verticalCenter),
        ];
        if (1 <= config.handicap) {
            turn = 1;
        }
        for (let i = 0; i < config.handicap; i++) {
            const handicapToPut = orderedHandicaps[i];
            board[handicapToPut.y][handicapToPut.x] = GoPiece.DARK;
        }
        return new GoState(board, PlayerNumberMap.of(0, 0), turn, MGPOptional.empty(), GoPhase.PLAYING);
    }
    getGoGroupDataFactory(zoom) {
        return new OrthogonalGoGroupDataFactory(zoom);
    }
}
